import Homepage from "./components/HomePage";
import LanguageChangeButton from "./Utils/Translations/LanguageChangeButton";

function App() {
  return (
    <div className="App">
      <Homepage />
      <LanguageChangeButton />
    </div>
  );
}

export default App;
